<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title
      :title="{ name: '所有内审单', path: '/apply/allReimburse' }"
      :button-array="buttonArray"
      @multPrint="multPrint"
    ></Title>
    <div style="margin: 10px auto">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px">
          <el-col :span="5">
            <el-input
              v-model="qparam.userName"
              placeholder="申请人姓名"
            ></el-input>
          </el-col>

          <el-col :span="5">
            <el-input
              v-model="qparam.reimburseNumber"
              placeholder="报销编号"
            ></el-input>
          </el-col>
          <el-col :span="9" v-show="solution">
            <el-date-picker
              v-model="qparam.month"
              type="month"
              value-format="yyyy-MM"
              placeholder="按月份查询"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="7" v-show="!solution">
            <el-date-picker
              v-model="applyTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>

          <el-col :span="5" style="float: right">
            <el-button
              icon="el-icon-refresh-left"
              type="primary"
              @click="resetQparam"
              >重置</el-button
            >
            <el-button
              icon="el-icon-search"
              type="primary"
              @click="initTableData"
              >查询</el-button
            >
          </el-col>
          <el-col :span="3" style="float: right; margin: 6px 16px 0px 0px">
            <el-switch v-model="solution" active-text="按月查询"> </el-switch>
          </el-col>
        </el-row>
      </el-card>
    </div>

    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="报销人">
            <template slot-scope="scope">
              <span>{{ scope.row.userName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="报销总金额">
            <template slot-scope="scope">
              <span>￥{{ scope.row.reimburseMoney }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="applyTime" label="报销时间"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="handleDetail(scope.$index, scope.row)"
                >查看申请
              </el-button>
              <el-button
                size="mini"
                type="info"
                @click="print(scope.$index, scope.row)"
                >打印
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 40px auto; width: 30%">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentPageChangeEvent"
            :current-page="qparam.current"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements"
          >
          </el-pagination>
        </div>
      </el-card>

      <el-dialog
        title="查看详情"
        :visible.sync="reimburseShow"
        width="1200px"
        top="6vh"
      >
        <div style="float: right; margin-right: 20px; clear: both">
          编号: {{ dialog.reimburseNumber }}
        </div>
        <el-table :data="reimburseList" :cell-style="{ color: 'black' }">
          <el-table-column
            fixed
            prop="projectOrOffice"
            label="报销类型"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.projectOrOffice == 1">项目费用</span>
                <span v-if="scope.row.projectOrOffice == 2">管理费用</span>
              </div>
              <div>
                <!-- <span style="color: #409EFF">{{ scope.row.projectName }}</span>-->
                <el-button
                  plain
                  type="primary"
                  size="mini"
                  v-if="scope.row.projectOrOffice == 1"
                  @click="handleProjectDetail(scope.row.projectId)"
                  >项目信息
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="reimburseType" label="报销名目" align="center">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.reimburseType == 1">交通费</span>
                <span v-if="scope.row.reimburseType == 9">路桥费</span>
                <span v-if="scope.row.reimburseType == 2">油费</span>
                <span v-if="scope.row.reimburseType == 3">招待费</span>
                <span v-if="scope.row.reimburseType == 4">住宿费</span>
                <span v-if="scope.row.reimburseType == 5">餐补</span>
                <span v-if="scope.row.reimburseType == 6">办公费</span>
                <span v-if="scope.row.reimburseType == 7">办公费</span>
                <span v-if="scope.row.reimburseType == 10">礼品费</span>
                <span v-if="scope.row.reimburseType == 11">福利费</span>
                <span v-if="scope.row.reimburseType == 8">其他</span>
              </div>
              <span
                v-if="
                  scope.row.projectOrOffice == 1 && scope.row.reimburseType == 3
                "
                style="color: #409eff"
              >
                <el-button
                  plain
                  type="primary"
                  size="mini"
                  @click="handleCostReportDetail(scope.row.costReportId)"
                  >招待详情</el-button
                >
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="reimburseMoney"
            label="报销金额"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="spendTime" label="费用产生时间" align="center">
          </el-table-column>

          <el-table-column prop="spendTime" label="外出信息" align="center">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.originAddress"
                  >出发地:{{ scope.row.originAddress }}</span
                >
                <span v-else>出发地:无</span>
              </div>
              <div>
                <span v-if="scope.row.endAddress"
                  >目的地:{{ scope.row.endAddress }}</span
                >
                <span v-else>出发地:无</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="remarks" label="费用事由" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.remarks">{{ scope.row.remarks }}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
        </el-table>

        <div
          style="
            float: right;
            margin-top: 5px;
            margin-right: 20px;
            clear: both;
          "
        >
          总金额: ￥{{ dialog.reimburseMoney }}元
        </div>
      </el-dialog>

      <el-dialog title="项目信息" :visible.sync="projectShow" width="1200px">
        <ProjectDialog :projectId="projectId"></ProjectDialog>
      </el-dialog>

      <el-dialog
        title="招待费报备详情"
        :visible.sync="costReportShow"
        width="1200px"
      >
        <CostReportDialog :costReportId="costReportId"></CostReportDialog>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  requestAllReimburse,
  requestReimburseDetail,
  requestPrintReimburse,
  requestPrintReimburseByMonth,
} from "../../../api";
import Title from "../../Title";
import CostReportDialog from "../../item/common/CostReportDialog";
import ProjectDialog from "../../item/common/ProjectDialog";

export default {
  name: "AllReimburse",
  components: { ProjectDialog, CostReportDialog, Title },
  data() {
    return {
      tableData: [],
      totalElements: 0,
      qparam: {
        current: 1,
        size: 10,

        userName: "",
        auditName: "",
        reimburseNumber: "",

        month: "",
      },
      apply: {},
      applyTime: [],
      reimburseShow: false,
      reimburseList: [],

      projectShow: false,
      costReportShow: false,

      projectId: "",
      costReportId: "",

      dialog: {
        reimburseMoney: 0,
        reimburseNumber: "",
      },
      buttonArray: [
        {
          type: "primary",
          title: "打印",
          method: "multPrint",
          disabled: false,
        },
      ],
      solution: false,
    };
  },
  computed: {
    ...mapState(["flowData"]),
  },
  methods: {
    handleProjectDetail(projectId) {
      this.projectShow = true;
      this.projectId = projectId;
    },
    handleCostReportDetail(costReportId) {
      this.costReportShow = true;
      this.costReportId = costReportId;
    },

    // 内审单详情
    getReimburseDetail(reimburseSingleId) {
      requestReimburseDetail({
        reimburseSingleId: reimburseSingleId,
      }).then((res) => {
        if (res.code == 200) {
          if (res.object) {
            this.reimburseList = res.object;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.initTableData();
    },
    resetQparam() {
      this.solution = false;
      this.qparam.applyType = "";
      this.applyTime = [];
      this.qparam.month = "";
      this.qparam.userName = "";
      this.qparam.auditName = "";
      this.qparam.reimburseNumber = "";
      this.initTableData();
    },
    handleDetail(index, row) {
      this.reimburseShow = true;
      this.dialog.reimburseMoney = row.reimburseMoney;
      this.dialog.reimburseNumber = row.reimburseNumber;
      this.getReimburseDetail(row.reimburseSingleId);
    },
    currentPageChangeEvent(currentPage) {
      this.qparam.current = currentPage;
      this.initTableData();
    },
    async initTableData() {
      this.qparam.startTime = this.applyTime[0];
      this.qparam.endTime = this.applyTime[1];
      if (this.solution) {
        if (!this.qparam.month) {
          this.$message.info("请选择月份");
          return;
        }
        console.log("选择的月份",this.qparam.month)
        // this.qparam.startTime = this.qparam.month + "-01 00:00:00";
        // this.qparam.endTime = this.qparam.month + "-31 23:59:59";
      }
      const res = await requestAllReimburse(this.qparam);
      if (res.code == 200) {
        this.totalElements = res.total;
        this.tableData = res.rows;
      } else {
        this.$message.error(res.msg);
      }
    },
    print(index, row) {
      requestPrintReimburse({ reimburseSingleId: row.reimburseSingleId }).then(
        (res) => {
          if (res.code == 200) {
            window.location.href = res.object;
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    multPrint() {
      if (!this.solution) {
        this.$message.info("目前只能按月打印，请选择按月查询");
        return;
      }
      if (!this.qparam.month) {
        this.$message.error("请选择月份");
        return;
      }
      // this.qparam.startTime = this.qparam.month + "-01 00:00:00";
      // this.qparam.endTime = this.qparam.month + "-31 23:59:59";
      console.log("导出选择的月份",this.qparam.month)
      const param = {
        startTime: this.qparam.startTime,
        endTime: this.qparam.endTime,
        month: this.qparam.month,
      };
      requestPrintReimburseByMonth(param).then((res) => {
        if (res.code == 200) {
          window.location.href = res.object;
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
  created() {
    this.initTableData();
  },
};
</script>

<style scoped></style>
